export const ANALYTICS_EVENT_FIRED = 'ANALYTICS_EVENT_FIRED'
export const ANALYTICS_EVENT_SENT = 'ANALYTICS_EVENT_SENT'
export const ANALYTICS_INITIATED = 'ANALYTICS_INITIATED'
